import { udSentry } from '@udemy/sentry';
import { useDynamicWebContentQuery } from '../../graphql/api-platform-graphql';

/**
 * We use this function to determine if we should enable preview mode for the dynamic web content data source.
 *
 * The team that configures the org logos in their application (currently Contentful) can preview the content in
 * the CMS without publishing to production. This is done by adding a query param to the URL.
 *
 * i.e https://www.udemy.com/?preview_mode=true
 */
const PREVIEW_MODE_SEARCH_PARAM = 'preview_mode';
export const getContentPreviewMode = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(PREVIEW_MODE_SEARCH_PARAM) === 'true';
};
export const useFetchPartnersLogos = pageType => {
  const {
    data,
    isLoading,
    isError,
    error,
    ...rest
  } = useDynamicWebContentQuery({
    pageType,
    isContentPreviewEnabled: getContentPreviewMode()
  }, {
    refetchOnWindowFocus: false
  });
  if (isError) {
    udSentry.captureException(error);
  }
  return {
    isLoading,
    isError,
    data: data === null || data === void 0 ? void 0 : data.dynamicWebContent,
    rawResponse: rest
  };
};
//# sourceMappingURL=use-fetch-partners-logos.js.map